var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70491 12.0317V1.15747C9.70491 0.850489 9.58296 0.556082 9.3659 0.339015C9.14883 0.121947 8.85442 0 8.54744 0C8.24046 0 7.94606 0.121947 7.72899 0.339015C7.51192 0.556082 7.38997 0.850489 7.38997 1.15747V14.8425C7.38997 15.9546 8.79935 16.415 9.46666 15.5437L12.8133 12.1972C13.0298 11.98 13.1513 11.6857 13.1511 11.3791C13.1508 11.0724 13.0289 10.7783 12.8121 10.5614C12.5952 10.3446 12.3011 10.2227 11.9945 10.2224C11.6878 10.2222 11.3935 10.3437 11.1763 10.5603L9.70491 12.0317ZM5.76116 14.8425V1.15747C5.76116 0.0454688 4.35179 -0.415 3.68447 0.456281L0.337817 3.80284C0.121275 4.02002 -0.000224189 4.31426 3.1056e-07 4.62095C0.00022481 4.92763 0.122155 5.22169 0.339015 5.43855C0.555875 5.65541 0.849935 5.77734 1.15662 5.77757C1.46331 5.77779 1.75755 5.65629 1.97472 5.43975L3.44616 3.96831V14.8425C3.44616 15.1495 3.56811 15.4439 3.78518 15.661C4.00224 15.8781 4.29665 16 4.60363 16C4.91061 16 5.20502 15.8781 5.42208 15.661C5.63915 15.4439 5.7611 15.1495 5.7611 14.8425H5.76116Z",
    fill: "#7E7E8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.c66032f975f2104f002797273c2b220c.svg";
export { ForwardRef as ReactComponent };